module.exports = __webpack_public_path__ + "static/img/webcache.e741bff0.svg";